import axios from 'axios';
import { baseUrl, HttpMethods } from '../../base';
import type {
  IGetApplicationFormNotificationsService,
  IGetApplicationFormNotificationsServiceRes,
  IPutApplicationFormStatusNotificationService,
  IPutApplicationFormStatusNotificationServiceRes,
} from './types';

const applicationFormRootPath = `${baseUrl.ROVER}/application_forms`;

export async function getApplicationFormNotifications({ applicationFormId }: IGetApplicationFormNotificationsService) {
  const res = await axios({
    method: HttpMethods.GET,
    url: `${applicationFormRootPath}/${applicationFormId}/notifications`,
  });
  return res.data as IGetApplicationFormNotificationsServiceRes;
}

export async function putApplicationFormStatusNotification({
  applicationFormId,
  statusId,
  data,
}: IPutApplicationFormStatusNotificationService) {
  const res = await axios({
    method: HttpMethods.POST,
    url: `${applicationFormRootPath}/${applicationFormId}/notifications/${statusId}`,
    data,
  });
  return res.data as IPutApplicationFormStatusNotificationServiceRes;
}
